"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDRESS_FORM = void 0;
var ADDRESS_FORM = {
  INPUT__STREET_ADDRESS: 'addressForm-input-streetAddress',
  INPUT__CITY: 'addressForm-input-city',
  INPUT__ZIP_CODE: 'addressForm-input-zipCode',
  INPUT__COUNTRY: 'addressForm-input-country',
  INPUT__STATE: 'addressForm-input-state'
};
exports.ADDRESS_FORM = ADDRESS_FORM;